export const AdditionalComponentsTestIds = {
  ADD_RECORD_BUTTON: 'financials-title.add-record-button',
  HIDE_CLOSED_LIABILITIES_CHECKBOX: 'additional-navigation.hide-closed-liabilities-checkbox',
};
